(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedReportDialogController', MedReportDialogController);

    MedReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedReport', 'Customer', 'Employee', 'MedReportLine'];

    function MedReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedReport, Customer, Employee, MedReportLine) {
        var vm = this;
        vm.medReport = entity;
        vm.customers = Customer.query();
        vm.employees = Employee.query();
        vm.medreportlines = MedReportLine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:medReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.medReport.id !== null) {
                MedReport.update(vm.medReport, onSaveSuccess, onSaveError);
            } else {
                MedReport.save(vm.medReport, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
